import React from "react";
import { Button } from "antd";
import { ROUTES } from "../../../core/router";

export const ExtraLayout = (onSubmit, navigateTo, t) => {
  return (
    <div className="extra-layout-div">
      <Button
        onClick={() => navigateTo(ROUTES.DASHBOARD)}
        style={{ marginRight: 30 }}
        danger
        className="login-form-button"
      >
        {t("user_create_user_extra_layout_cancel")}
      </Button>
      <Button
        htmlType="submit"
        type="primary"
        onClick={onSubmit}
        className="login-form-button"
      >
        {t("user_create_user_extra_layout_submit")}
      </Button>
    </div>
  );
};
